exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header[data-v-3f5c9ead]{padding:13px 13px 13px 20px;background:#2564f5;border-top-left-radius:4px;border-top-right-radius:4px;border:1px solid #20459d}header h5[data-v-3f5c9ead]{text-transform:uppercase;font-weight:500;color:#fff;overflow:hidden;text-overflow:ellipsis;font-size:12px;margin:0}section[data-v-3f5c9ead]{padding-top:10px;border:1px solid #eceff9;overflow:hidden;position:relative}", ""]);

// exports
